import { Col, Flex, Row, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ImageCapturePageFormCard } from "./components/ImageCapturePageFormCard";
import {
  fetchImageCapturePageById,
  fetchImageCapturePageTypes,
  updateImageCapturePageById,
} from "@/lib/api/resources/imageCapturePages";
import type {
  ImageCapturePage,
  ImageCapturePageType,
} from "@rumble-it/common-lib/types/models/ImageCapture.interface";

export const ImageCapturePageEdit = () => {
  const { id: imageCaptureId, pageId } = useParams();
  const navigate = useNavigate();

  if (!imageCaptureId || !pageId) {
    message.error(
      "Ongeldige of ontbrekende parameters voor het bewerken van de pagina.",
    );
    return null;
  }

  const { data, isLoading } = useQuery<ImageCapturePage>({
    queryKey: ["imageCapturePage", pageId],
    queryFn: () => fetchImageCapturePageById(pageId as string),
    enabled: !!pageId,
  });

  const { data: pageTypes, isLoading: isPageTypesLoading } = useQuery({
    queryKey: ["imageCapturePageTypes"],
    queryFn: fetchImageCapturePageTypes,
  });

  const pageTypesOptions = Array.isArray(pageTypes)
    ? pageTypes.map((page: ImageCapturePageType) => ({
        label: page.name,
        value: page["@id"],
      }))
    : [];

  const updateMutation = useMutation({
    mutationFn: async (data: ImageCapturePage) =>
      updateImageCapturePageById(pageId as string, data),
    onSuccess: () => {
      navigate(`/image-captures/${imageCaptureId}/pages/${pageId}`);
      message.success("Pagina succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de pagina",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Flex vertical gap={16}>
          <ImageCapturePageFormCard
            title="Pagina bijwerken"
            buttonText="Bijwerken"
            loading={isPageTypesLoading || isLoading}
            pageTypes={pageTypesOptions}
            initialValues={data}
            mutation={updateMutation}
          />
        </Flex>
      </Col>
    </Row>
  );
};
